// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1211":"d5ca8e95","4559":"dfb19ff2"}[chunkId] + ".chunk.css";
};